<template>
    <div class="detail">
        <product-part-one :product_id="product_id" mode="2" />
        <product-part-four :product_id="product_id" />
        <product-part-three :product_id="product_id" />


        <van-divider>我是底线</van-divider>
        <van-goods-action>
            <van-goods-action-icon icon="shop-o" text="首页" @click="go_home" />
            <van-goods-action-icon icon="chat-o" text="客服" @click="showCS" />
            <van-goods-action-button class="footer-button" type="danger" text="立即购买" @click="buy_it" />
        </van-goods-action>
    </div>
</template>

<script>
    import ProductPartOne from "../../components/Product/ProductPartOne";
    import ProductPartThree from "../../components/Product/ProductPartThree";
    import ProductPartFour from "../../components/Product/ProductPartFour";
    import { mapActions } from 'vuex';
    import store from '@/store';
    import config from '@/config';

    export default {
        name: "ProductDetailSale",
        components: {ProductPartFour, ProductPartThree, ProductPartOne},
        data(){
            return{
                product_id:this.$route.params.product_id,
                sales_uid:this.$route.params.sales_uid,     //渠道id（系统中的uid）
                weixin_code:this.$route.query.code,         //query：获取url中get模式参数
                weixin_state:this.$route.query.state,
                openid:this.$store.getters.getLoginUser.openid, //当前购买客户的open_id
            }
        },
        methods:{
            ...mapActions([
                'getUserPromotePoster',
                'GetAppCSInfo',
            ]),
            buy_it(){
                let product_id=this.product_id;
                let sales_uid=this.sales_uid;
                this.$router.push({name:'CreateOrder',params:{product_id,sales_uid}});
            },
            go_home(){
                this.$router.push({name:'home'});
            },
            loadCSInfo(){
                let mode=2;
                this.GetAppCSInfo({mode}).then(res=>{
                    this.cs=res;
                })
            },
            showCS(){
                this.$imagePreview([this.cs.avatar]);
            },
        },
        mounted() {
            this.$store.commit('setMySalesId',this.sales_uid);  //将当前渠道号暂存
            this.loadCSInfo();
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            // console.log('login user',loginUser);
            if(loginUser&&loginUser.openid){
                next();
            }else{
                //未登录，则发起微信登录授权
                let code = to.query.code;
                let sales_uid=to.params.sales_uid;
                let mode=1; //梅唐四季模式
                // console.log('微信code值',code);
                // console.log('渠道号值',sales_uid);
                if(code){
                    // console.log('----- 开始调用后台微信登录接口 ------');
                    store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                        // console.log('返回对象',res);
                        if(res.status>0){
                            //登录失败
                            next(false);
                        }else{
                            //成功
                            next();
                        }
                    });
                }else{
                    //无code则表示是第一次进入本页，发起微信授权
                    // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev); //debug
                    let redirect_uri = encodeURIComponent(window.location.href);
                    let appid=config.weixin.appid_mt;
                    let state=''; //'product-detail-sale/1004/1002'; //debug
                    let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +appid+
                        '&redirect_uri=' +redirect_uri+
                        '&response_type=code&scope=snsapi_userinfo&' +
                        'state=' +state+
                        '#wechat_redirect';
                    console.log('weixin auth url',auth_url);
                    window.location.href = auth_url;
                }
            }
        },

    }
</script>

<style lang="scss" scoped>
    .detail{
        background-color: #F3F4F5;
    }
    .footer-button{
        margin-left: 5px;
        border-radius: 20px;
    }
</style>
